import React, { useEffect, useState } from "react";
import Button from "../Components/RequestsOverView/Button";
import RequestComment from "../features/MyRequests/SubComponents/Comments/RequestComment";
import LoaderComponent from "./LoaderComponent";
import noCommentIcon from '../assets/noComments.svg'
import { addRequestComment,deleteRequestComment } from "../apis/requests";
import Popup from "../ReusableFunctions/Popup";
import { set } from "lodash";

const VerticalStepper = ({ steps,isCommentEditable, requestId,comments,isLoading,onCommentAdd,onCommentDelete}) => {
  const [comment, setComment] = useState(undefined);
  const [mode, setMode] = useState("history");
  const [loading, setLoading] = useState(false);
  const [commentError, setCommentError] = useState(undefined);

  const validateComment = (text) => {
    if (!text || text.length < 8) {
      setCommentError("at least 8 characters long");
      return false;
    } else if (text.length > 100) {
      setCommentError("Max 100 characters allowed");
      return false;
    } else {
      setCommentError("");
      return true;
    }
  };

  const handleCommentChange = (e) => {
    const text = e.target.value;
    setComment(text);
    validateComment(text);
  };

  const handleAddNewComment = async () => {
    if (!validateComment(comment)) return;
    
    try {
      setLoading(true);
      const {comment: addedComment, message} = await addRequestComment({req_id: requestId, content: comment});
      setComment("");
      onCommentAdd(addedComment);
    } catch(err) {
      setLoading(false);
      Popup.alert("ERROR", err || "something went wrong while adding comment", "ERROR");
    } finally {
      setLoading(false);
    }
  }
  
  useEffect(() => {
    setCommentError(undefined);
    setComment("");
    setMode("history");
  }, [requestId]);

  return (
    <>
     {!isLoading && (
      <>
       <div className="steper_toggle_button_wrapper">
        <div
          onClick={() => {
            setMode("history");
          }}
          className={`${
            mode === "history" ? "selected_step_button" : "inactive_step_button"
          } step_button`}
        >
          <span className="font-manrope font-[500] text-[15px]">History</span>
        </div>
        <div
          onClick={() => {
            setMode("comments");
          }}
          className={`${
            mode === "comments"
              ? "selected_step_button"
              : "inactive_step_button"
          } step_button`}
        >
          <span className="font-manrope font-[500] text-[15px]">Comments</span>
        </div>
      </div>
      
      {mode === "history" ? (
        <div className="vertical-stepper">
          <div className="steps">
            {steps &&
              steps?.map((step, index) => (
                <div
                  key={index}
                  className={`step`}
                  style={{
                    borderLeft:
                      steps.length == index + 1
                        ? `2px solid #e2744400`
                        : `2px solid ${step.statusColor || "#23c329"}`,
                  }}
                >
                  <div
                    className="step-dot"
                    style={{
                      backgroundColor: step.statusColor || "#23c329",
                      borderColor: step.statusColor || "#23c329",
                      border: step.highlightStatus
                        ? steps.length == index + 1
                          ? `4px solid #ffbda0`
                          : `2px solid ${step.statusColor || "#23c329"}`
                        : `2px solid ${step.statusColor || "#23c329"}`,
                      height: step.highlightStatus
                        ? steps.length == index + 1
                          ? "18px"
                          : "14px"
                        : "14px",
                      width: step.highlightStatus
                        ? steps.length == index + 1
                          ? "18px"
                          : "14px"
                        : "14px",
                      left: step.highlightStatus
                        ? steps.length == index + 1
                          ? "-10px"
                          : "-8px"
                        : "-8px",
                    }}
                  ></div>
                  <div className="step-content">
                    <div className="step-label" title={step.label || ""}>
                      {step.label}
                    </div>
                    <div className="step-description">{step.content}</div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      ) : (
        <div className="comments_stepper">
          <div className={`comments_section ${!isCommentEditable?"full_comments_section":""}`}>
            {loading  ? (
              <LoaderComponent top={"-20px"} width={"10%"} height={"10%"} />
            ) : comments && comments.length > 0 ? (
              <RequestComment onDeleteComment={async(id)=>{
                try{
                 setLoading(true);
                 const {comment,message}=await deleteRequestComment(id);
                 onCommentDelete(comment?.id)
                }catch(err){
                  setLoading(false);
                  Popup.alert("ERROR",err || "something went wrong while deleting comment","ERROR");
                }finally{
                  setLoading(false);
                }
              }}  comments={comments} />
            ) : (
              <div className="no-comments-message">
                <div className="no_comments_wrapper">
                <div className="no-comments-icon">
                  <img src={noCommentIcon} alt={"no-comments"}/>
                </div>
                <p className="text-[#3B3B3B] text-[12px] font-manrope max-w-[85%] text-center mt-2">Add a comments about your order. Pilots can see it, and you can see their comments.</p>
                  </div>
              </div>
            )}
          </div>
          
         {isCommentEditable && ( <div className="add_comment_section">
            <textarea 
              onChange={handleCommentChange}
              className={`comment_input ${commentError?"comment_input_error":""}`}
              rows={"4"} 
              value={comment || ""}
              placeholder="Type your comment here"
            />
            {commentError && (
              <div className="h-[8%] w-full pl-4 text-sm mt-1 mb-2 text-red-500">
                {commentError}
              </div>
            )}
            <Button
              variant={"filled"}
              title={"Add"}
              isDisbaled={!comment || comment.length < 8 || comment.length > 100}
              handleClick={handleAddNewComment}
              width={"90%"}
              color={"#0F5EFF"}
              hoverColor={"#0F5EFF"}
              iconStyle={{ width: 16, height: 16 }}
            />
          </div>)}
        </div>
      )}
      </>
     )}
    </>
  );
};

export default VerticalStepper;